import { render, staticRenderFns } from "./TipsWrap.vue?vue&type=template&id=4eebcf41&scoped=true"
import script from "./TipsWrap.vue?vue&type=script&lang=js"
export * from "./TipsWrap.vue?vue&type=script&lang=js"
import style0 from "./TipsWrap.vue?vue&type=style&index=0&id=4eebcf41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebcf41",
  null
  
)

export default component.exports